import {
  Tooltip,
  Stack,
  Typography,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  FormControl,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
import React, { useState, useEffect, useRef, useCallback } from "react";
import RestoreIcon from "@mui/icons-material/Restore";
import IconButton from "@mui/material/IconButton";
// Imports from common components
import CommonAgGrid from "./common/CommonAgGrid/CommonAgGrid";
import CustomDatePicker from "altopenergy.customdatepicker";
import CustomAccordion from "./common/CustomAccordion";
import { apiFetch } from "../utils/auth";
import { getColumnDefsFromData, mergeLMPByHourEnding } from "../utils";
import { useMemo } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import { CustomTooltipCell } from "./common/CustomTooltip";
import BackgroundContainer from "./common/BackgroundContainer";

const MISO = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const red = theme.palette.customColors.pnlRed;
  const green = theme.palette.customColors.pnlGreen;
  // States
  const [countdown, setCountdown] = useState(15);
  const [CurrentTime, setCurrentTime] = useState("");
  const [DALMP, setDALMP] = useState([]);
  const [DALMP_AVG, setDALMP_AVG] = useState("");
  const [UpdatedCustomRowDataFixed, setUpdatedCustomRowDataFixed] = useState(
    [],
  );
  const [DALMP_ColumnDefs, setDALMP_ColumnDefs] = useState([
    { field: "HE", headerName: "HE", flex: 1 },
    {
      field: "LMP",
      headerName: "LMP",
      flex: 1,
      cellStyle: (params) => {
        const row = params.data;
        const hourEnding = row.HourEnding;
        if (hourEnding === currentHE) {
          return { backgroundColor: "#90CAF9", color: "black" };
        }
      },
    },
  ]);
  const [DayAheadRowData, setDayAheadRowData] = useState([]);

  const [DAClass, setDAClass] = useState("OnPeak");

  const [Hybrid, setHybrid] = useState([]);
  const [Hybrid_ColumnDefs, setHybrid_ColumnDefs] = useState();
  const [Hybrid_AVG, setHybrid_AVG] = useState("");
  const [HybridRowData, setHybridRowData] = useState([]);
  const [MISOPrices, setMISOPrices] = useState([]);
  const [MISOPrices_ColumnDefs, setMISOPrices_ColumnDefs] = useState([
    {
      field: "Interval",
      headerName: "Tick",
      flex: 1,
      cellStyle: (params) => ({
        fontSize: "16px",
      }),
    },
    {
      field: "ExAnte",
      headerName: "Ex Ante",
      flex: 1,
      cellStyle: (params) => ({
        fontSize: "16px",
      }),
    },
    {
      field: "ExPost",
      headerName: "Ex Post",
      flex: 1,
      valueFormatter: (p) => (p.value === "" || p.value == null ? "" : p.value),
      cellStyle: (params) => ({
        fontSize: "16px",
      }),
    },
    {
      field: "Change",
      headerName: "Change",
      flex: 1,
      cellClass: (params) => {
        const change = params.value; // AG Grid provides the value here
        if (change > 0) return "positive-cell";
        if (change < 0) return "negative-cell";
        return null;
      },
      cellStyle: (params) => ({
        fontSize: "16px",
      }),
    },
  ]);
  const [LatestMisoPrice, setLatestMisoPrice] = useState("");
  const [LatestMisoPriceChange, setLatestMisoPriceChange] = useState("");
  const [LatestMisoPriceType, setLatestMisoPriceType] = useState("");
  const [MISOAce, setMISOAce] = useState("");
  const [MISOAceTimestamp, setMISOAceTimestamp] = useState("");
  const [MISOAceDelta, setMISOAceDelta] = useState("");
  const [flowDate, setflowDate] = useState(dayjs());
  const [useExAnte, setuseExAnte] = useState(true);
  const [useDAHybrid, setuseDAHybrid] = useState(true);
  const [currentHE, setcurrentHE] = useState("");
  const [DAHybrid, setDAHybrid] = useState("");
  const [MISOLatestDispatchTimestamp, setMISOLatestDispatchTimestamp] =
    useState("");
  const dateRef = useRef();
  const [Custom, setCustom] = useState([]);
  const [Custom_ColumnDefs, setCustom_ColumnDefs] = useState();
  //  Api Calls
  const funcFetchDALMP = (shouldTrack) => {
    apiFetch("balday/getTopTables", {
      method: "POST",
      body: JSON.stringify({
        ISO: "MISO",
        FlowDate: dateRef.current || flowDate.format("YYYY-MM-DD"),
      }),
      track: shouldTrack,
    })
      .then((res) => res.json())
      .then((res) => {
        setDALMP(res.DALMP);
        setDALMP_AVG(res.DALMP_AVG);
        setHybrid(res.Hybrid);
        setMISOAce(res.AceValue);
        setMISOAceTimestamp(res.AceTime);
        setMISOAceDelta(res.AceDelta);
        setMISOPrices(res.MISOPrices);
        setLatestMisoPrice(res.LatestPrice);
        setLatestMisoPriceChange(res.LatestChange);
        setLatestMisoPriceType(res.LatestPriceType);
        setcurrentHE(res.CurrentHourEnding);
        setDAHybrid(res.DAHybridValue);
        setMISOLatestDispatchTimestamp(res.LatestMISODispatchTimestamp);
      });
  };

  const funcModifyCustom = (shouldTrack) => {
    apiFetch("balday/modifyCustom", {
      method: "POST",
      body: JSON.stringify({
        Custom: Hybrid,
        MISOPrices: MISOPrices,
        ISO: "MISO",
        HourEnding: currentHE,
      }),
      track: shouldTrack,
    })
      .then((res) => res.json())
      .then((res) => {
        setCustom(
          mergeLMPByHourEnding(
            res.Custom,
            UpdatedCustomRowDataFixed,
            currentHE,
          ),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (!DALMP) return;

    if (DAClass === "OnPeak") {
      const updatedData = DALMP.filter((row) => row.OnPeak);
      const meanLMP = (
        updatedData.reduce((sum, row) => sum + row.LMP, 0) / updatedData.length
      ).toFixed(2);
      setDayAheadRowData(DALMP.filter((row) => row.OnPeak));
      setDALMP_AVG(meanLMP);
    } else if (DAClass === "OffPeak") {
      const updatedData = DALMP.filter((row) => !row.OnPeak);
      const meanLMP = (
        updatedData.reduce((sum, row) => sum + row.LMP, 0) / updatedData.length
      ).toFixed(2);
      setDayAheadRowData(DALMP.filter((row) => !row.OnPeak));
      setDALMP_AVG(meanLMP);
    } else {
      const meanLMP = (
        DALMP.reduce((sum, row) => sum + row.LMP, 0) / DALMP.length
      ).toFixed(2);
      setDayAheadRowData(DALMP);
      setDALMP_AVG(meanLMP);
    }
  }, [DALMP, DAClass]);

  useEffect(() => {
    if (!Hybrid) return;

    if (DAClass === "OnPeak") {
      const updatedData = Hybrid.filter((row) => row.OnPeak);
      setHybridRowData(updatedData);
      setHybrid_AVG(
        (
          updatedData.reduce((sum, row) => sum + row.LMP, 0) /
          updatedData.length
        ).toFixed(2),
      );
    } else if (DAClass === "OffPeak") {
      const updatedData = Hybrid.filter((row) => !row.OnPeak);
      setHybridRowData(updatedData);
      setHybrid_AVG(
        (
          updatedData.reduce((sum, row) => sum + row.LMP, 0) /
          updatedData.length
        ).toFixed(2),
      );
    } else {
      setHybridRowData(Hybrid);
      setHybrid_AVG(
        (Hybrid.reduce((sum, row) => sum + row.LMP, 0) / Hybrid.length).toFixed(
          2,
        ),
      );
    }
  }, [Hybrid, DAClass]);

  useEffect(() => {
    // --- Set initial countdown ---
    setCountdown(15);

    const intervalId = setInterval(() => {
      // --- Update CST Time every second ---
      const nowCST = new Date().toLocaleTimeString("en-US", {
        timeZone: "America/Chicago",
        hour12: false,
      });

      setCurrentTime(nowCST);

      // --- Countdown + auto-fetch ---
      setCountdown((prev) => {
        if (prev === 1) {
          // Time to refresh (with false)
          funcFetchDALMP(false);

          return 15; // reset countdown
        }
        return prev - 1; // tick down
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (useExAnte) {
      funcModifyCustom(false);
    } else {
      setCustom(
        mergeLMPByHourEnding(Hybrid, UpdatedCustomRowDataFixed, currentHE),
      );
    }
  }, [useExAnte, Hybrid]);

  const Custom_RowData = useMemo(() => {
    if (!Custom || Custom.length === 0) return [];

    // Step 1: Apply DAHybrid for currentHE if needed
    let data = Custom.map((item) =>
      useDAHybrid && item.HourEnding == currentHE
        ? { ...item, LMP: DAHybrid }
        : item,
    );

    // Step 2: Filter based on DAClass
    if (DAClass === "OnPeak") {
      data = data.filter((row) => row.OnPeak);
    } else if (DAClass === "OffPeak") {
      data = data.filter((row) => !row.OnPeak);
    }

    return data;
  }, [Custom, useDAHybrid, currentHE, DAHybrid, DAClass]);

  // Calculate average LMP for filtered data
  const Custom_AVG = useMemo(() => {
    if (!Custom_RowData || Custom_RowData.length === 0) return 0;

    const total = Custom_RowData.reduce(
      (sum, row) => sum + Number(row.LMP || 0),
      0,
    );
    return (total / Custom_RowData.length).toFixed(2);
  }, [Custom_RowData]);

  useEffect(() => {
    dateRef.current = flowDate.format("YYYY-MM-DD");
    funcFetchDALMP(true);
  }, [flowDate]);

  useEffect(() => {
    setCustom_ColumnDefs([
      {
        field: "LMP",
        headerName: "LMP",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          }
        },
        editable: (params) => {
          const he = params.data.HourEnding;

          // Rule 1: Hybrid mode + current HE → disable
          if (useDAHybrid && he === currentHE) return false;

          // Rule 2: Disable for past hours
          if (he < currentHE) return false;

          // Otherwise editable
          return true;
        },
        cellEditor: "agNumberCellEditor",
        suppressKeyboardEvent: (params) => {
          const key = params.event.key;

          if (params.editing && (key === "ArrowUp" || key === "ArrowDown")) {
            // completely block editor from receiving arrow keys
            params.event.preventDefault();
            return true;
          }

          return false;
        },
        cellRenderer: (params) => {
          const value = params.value;
          const hourEnding = params.data.HourEnding;
          const showBoder = hourEnding >= Number(currentHE);

          return (
            <Box
              sx={{
                border: showBoder
                  ? theme.palette.mode === "dark"
                    ? "1px solid #ffffffbd"
                    : "1px solid #222222bd"
                  : "none",
                width: "100%",
              }}
            >
              {value}
            </Box>
          );
        },
      },
      {
        field: "Ticks",
        headerName: "Ticks",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          }
        },

        cellRenderer: (params) => {
          const rtlmp = params.value;
          const row = params.data;
          const hourEnding = row.HourEnding;
          const tableData = row.RTLMP_Intervals;

          return (
            <CustomTooltipCell
              tooltipContent={
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Interval</TableCell>
                        <TableCell>LMP</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{row.Interval}</TableCell>
                          <TableCell sx={{ color: row.LMP > 0 ? green : red }}>
                            {row.LMP !== null
                              ? Math.round(row.LMP * 10) / 10
                              : ""}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              }
              value={<Box>{rtlmp}</Box>}
            />
          );
        },
      },
    ]);
    setHybrid_ColumnDefs([
      {
        field: "LMP",
        headerName: "LMP",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          }
        },
      },
      {
        field: "Ticks",
        headerName: "Ticks",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HourEnding;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          }
        },
        cellRenderer: (params) => {
          const rtlmp = params.value;
          const row = params.data;
          const hourEnding = row.HourEnding;

          const tableData = row.RTLMP_Intervals;
          return (
            <CustomTooltipCell
              tooltipContent={
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Interval</TableCell>
                        <TableCell>LMP</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{row.Interval}</TableCell>
                          <TableCell sx={{ color: row.LMP > 0 ? green : red }}>
                            {row.LMP !== null
                              ? Math.round(row.LMP * 10) / 10
                              : ""}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              }
              value={
                <Box>
                  {rtlmp} {hourEnding < Number(currentHE) ? "✓" : ""}
                </Box>
              }
            />
          );
        },
      },
    ]);
    setDALMP_ColumnDefs([
      {
        field: "HE",
        headerName: "HE",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HE;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          }
        },
      },
      {
        field: "LMP",
        headerName: "LMP",
        flex: 1,
        cellStyle: (params) => {
          const row = params.data;
          const hourEnding = row.HE;
          if (hourEnding === currentHE) {
            return {
              backgroundColor: "#90CAF9",
              color: "black",
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          } else {
            return {
              fontSize:
                DAClass === "OnPeak" || DAClass === "OffPeak" ? "20px" : "16px",
            };
          }
        },
      },
    ]);
  }, [currentHE, theme, DAClass]);
  const isValidNumber = (v) => !Number.isNaN(Number(v));

  const handleCellValueChanged = (params) => {
    const { oldValue, newValue, colDef, node } = params;

    // Check if the column changed is "LMP"
    if (colDef.field === "LMP") {
      console.log("Old Value:", oldValue);
      console.log("New Value:", newValue);

      // Find the row being updated using HourEnding as the unique key
      const updatedRowData = Custom.map((row) => {
        if (row.HourEnding === node.data.HourEnding) {
          // Update the LMP field for the row with matching HourEnding
          return { ...row, LMP: newValue };
        }
        return row;
      });
      setUpdatedCustomRowDataFixed(JSON.parse(JSON.stringify(updatedRowData)));
      // Update state with the new row data
      setCustom(updatedRowData);
    }
  };

  const onCellKeyDown = useCallback((params) => {
    const event = params.event;
    const key = event.key;

    if (key !== "ArrowUp" && key !== "ArrowDown") return;

    // only for editable column
    if (!params.column.getColDef().editable) return;

    const api = params.api;
    const column = params.column;
    const rowIndex = params.node.rowIndex;

    event.preventDefault();
    event.stopPropagation();

    // stop editing current cell
    api.stopEditing();

    let nextRowIndex = key === "ArrowDown" ? rowIndex + 1 : rowIndex - 1;

    if (nextRowIndex < 0 || nextRowIndex >= api.getDisplayedRowCount()) {
      return;
    }

    // focus next cell
    api.setFocusedCell(nextRowIndex, column);

    // start editing after focus is applied
    setTimeout(() => {
      api.startEditingCell({
        rowIndex: nextRowIndex,
        colKey: column.getColId(),
      });
    }, 0);
  }, []);

  const onCellFocused = (params) => {
    if (!params.column) return;

    const colDef = params.column.getColDef();
    if (!colDef.editable) return;

    // delay editing until grid finishes focus cycle
    requestAnimationFrame(() => {
      params.api.startEditingCell({
        rowIndex: params.rowIndex,
        colKey: params.column.getColId(),
      });
    });
  };

  const resetCustom = () => {
    setUpdatedCustomRowDataFixed([]);
    funcModifyCustom(false);
  };
  return (
    <Stack>
      <BackgroundContainer>
        {/* Right section */}
        {isMobile ? (
          /* ------------------ MOBILE LAYOUT ------------------ */
          <Stack
            spacing={2}
            sx={{
              px: 2,
              py: 1.5,
            }}
          >
            {/* Row 1: Class + Date */}
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "space-around" }}
            >
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>Class:</Typography>
                <Select
                  value={DAClass}
                  onChange={(e) => setDAClass(e.target.value)}
                  size="small"
                  // fullWidth
                  sx={{ width: 180 }}
                >
                  <MenuItem value="OnPeak">ONPEAK</MenuItem>
                  <MenuItem value="OffPeak">OFFPEAK</MenuItem>
                  <MenuItem value="ATC">ATC</MenuItem>
                </Select>
              </Stack>

              <Stack>
                <Typography sx={{ fontSize: "14px" }}>
                  Choose a date:
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    value={flowDate}
                    onChange={(date) => setflowDate(dayjs(date))}
                    views={["year", "month", "day"]}
                    openTo="day"
                    slotProps={{ textField: { size: "small" } }}
                  />
                </LocalizationProvider>
              </Stack>
            </Stack>

            {/* Row 2: ACE */}
            <Stack
              direction={"row"}
              spacing={2}
              justifyContent={"space-between"}
            >
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>ACE:</Typography>
                <Typography sx={{ fontSize: "16px" }}>
                  <strong>{MISOAce}</strong> ({MISOAceDelta}) @
                  {MISOAceTimestamp} EST
                </Typography>
              </Stack>
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>Dispatch:</Typography>
                <Typography sx={{ fontSize: "16px" }}>
                  {MISOLatestDispatchTimestamp} CST ({countdown})
                </Typography>
              </Stack>
            </Stack>
            {/* Row 4: Toggles */}
            <Stack
              direction={"row"}
              spacing={2}
              sx={{ justifyContent: "space-between" }}
            >
              <Stack direction="column" spacing={0.75}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useDAHybrid}
                      onChange={(e) => setuseDAHybrid(e.target.checked)}
                    />
                  }
                  label="Use DAHybrid"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useExAnte}
                      onChange={(e) => setuseExAnte(e.target.checked)}
                    />
                  }
                  label="Use ExAnte"
                />
              </Stack>
              <Stack>
                <Typography sx={{ fontSize: "14px" }}>
                  Hour Ending: {currentHE}
                </Typography>
                <Typography sx={{ fontSize: "16px" }}>
                  DA Hybrid: {DAHybrid}
                </Typography>
              </Stack>
            </Stack>

            {/* Row 5: Hour Ending */}
          </Stack>
        ) : (
          <Box
            sx={{
              px: 30,
              py: 1.5,
              display: "grid",
              gridTemplateColumns: `
      120px
      270px
      160px

      180px
      170px
      180px
      180px
    `,
              columnGap: 3,
              alignItems: "start",
            }}
          >
            {/* CLASS */}
            <Box>
              <Typography fontSize={14}>Class:</Typography>
              <Select
                value={DAClass}
                onChange={(e) => setDAClass(e.target.value)}
                size="small"
                sx={{ width: 100 }}
              >
                <MenuItem value="OnPeak">ONPEAK</MenuItem>
                <MenuItem value="OffPeak">OFFPEAK</MenuItem>
                <MenuItem value="ATC">ATC</MenuItem>
              </Select>
            </Box>

            {/* ACE */}
            <Box>
              <Typography fontSize={14}>ACE:</Typography>
              <Typography
                fontSize={16}
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <strong>{MISOAce}</strong> ({MISOAceDelta}) @{MISOAceTimestamp}{" "}
                EST
              </Typography>
            </Box>

            {/* CURRENT TIME */}
            <Box>
              <Typography fontSize={14}>Current Time:</Typography>
              <Typography fontSize={16} whiteSpace="nowrap">
                {CurrentTime} CST
              </Typography>
            </Box>

            {/* DISPATCH */}
            <Box>
              <Typography fontSize={14}>Dispatch:</Typography>
              <Typography fontSize={16} whiteSpace="nowrap">
                {MISOLatestDispatchTimestamp} CST ({countdown})
              </Typography>
            </Box>

            {/* CHECKBOXES */}
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useDAHybrid}
                    onChange={(e) => setuseDAHybrid(e.target.checked)}
                  />
                }
                label="Use DAHybrid"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useExAnte}
                    onChange={(e) => setuseExAnte(e.target.checked)}
                  />
                }
                label="Use ExAnte"
              />
            </Box>

            {/* HE / HYBRID */}
            <Box>
              <Typography fontSize={14} whiteSpace="nowrap">
                Hour Ending: {currentHE}
              </Typography>
              <Typography fontSize={16} whiteSpace="nowrap">
                DA Hybrid: {DAHybrid}
              </Typography>
            </Box>

            {/* DATE PICKER */}
            <Box>
              <CustomDatePicker
                mode="single"
                label='Choose a date:'
                value={flowDate}
                onChange={(date) => {setflowDate(dayjs(date));}}
              />
            </Box>
          </Box>
        )}
      </BackgroundContainer>
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={8}
        sx={{
          paddingY: 2,
          alignItems: "flex-start", // Align items to the top of the container
          // display: "flex",
          px: 15,
          justifyContent: "flex-start", // Ensure they start from the left
        }}
      >
        <Stack
          sx={{
            padding: 0,
            borderRadius: 2,
            py: 2,
            display: "flex",
            flex: 1.5,
            minWidth: 0,
            width: isMobile && "100%",
            px: 1,
            border:
              theme.palette.mode === "dark"
                ? "1px solid #ffffffbd"
                : "1px solid #222222bd",
          }}
          spacing={1}
        >
          <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
            Day-Ahead
          </Typography>
          {/* ------- TOP ROW WITH DIVIDER ------- */}
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "center", // center horizontally
              alignItems: "center", // center vertically
            }}
          >
            {isValidNumber(DALMP_AVG) && (
              <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
                {DALMP_AVG}
              </Typography>
            )}
          </Stack>

          {/* ------- TABLE SECTION ------- */}
          <Stack
            sx={{
              overflowX: "hidden !important",
            }}
          >
            <CommonAgGrid
              rowData={DayAheadRowData}
              columnDefs={DALMP_ColumnDefs}
              className="custom-grid-theme"
              domLayout="autoHeight"
              headerHeight={30}
              rowHeight={
                DAClass === "OnPeak" || DAClass === "OffPeak" ? 40 : 30
              }
              defaultColumnDefs={{
                filter: true,
              }}
            />
          </Stack>
        </Stack>

        <Stack
          sx={{
            padding: 0,
            borderRadius: 2,
            py: 2,
            display: "flex",
            flex: 1.5,
            minWidth: 0,
            width: isMobile && "100%",
            px: 1,
            border:
              theme.palette.mode === "dark"
                ? "1px solid #ffffffbd"
                : "1px solid #222222bd",
          }}
          spacing={1}
        >
          <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
            Hybrid
          </Typography>
          {/* ------- TOP ROW WITH DIVIDER ------- */}
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "center", // center horizontally
              alignItems: "center", // center vertically
            }}
          >
            {isValidNumber(Hybrid_AVG) && (
              <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
                {Hybrid_AVG}
              </Typography>
            )}
          </Stack>

          {/* ------- TABLE SECTION ------- */}
          <Stack
            sx={{
              overflowX: "hidden !important",
            }}
          >
            <CommonAgGrid
              rowData={HybridRowData}
              columnDefs={Hybrid_ColumnDefs}
              headerHeight={30}
              rowHeight={
                DAClass === "OnPeak" || DAClass === "OffPeak" ? 40 : 30
              }
              className="custom-grid-theme"
              defaultColumnDefs={{
                filter: true,
              }}
              domLayout="autoHeight"
            />
          </Stack>
          <Typography sx={{ padding: 0.125 }}>
            ✓ Indicates Integrated LMP
          </Typography>
        </Stack>

        <Stack
          sx={{
            padding: 0,
            borderRadius: 2,
            pt: 2,

            display: "flex",
            flex: 1.5,
            minWidth: 0,
            width: isMobile && "100%",
            px: 1,
            border:
              theme.palette.mode === "dark"
                ? "1px solid #ffffffbd"
                : "1px solid #222222bd",
          }}
          spacing={1}
        >
          <Stack
            direction="row"
            spacing={0}
            justifyContent="center"
            alignItems="center"
          >
            <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
              Custom
            </Typography>
            <IconButton onClick={resetCustom}>
              <Tooltip title="Reset Custom">
                <RestoreIcon sx={{ fontSize: "30px" }} />
              </Tooltip>
            </IconButton>
          </Stack>
          {/* ------- TOP ROW WITH DIVIDER ------- */}
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "center", // center horizontally
              alignItems: "center", // center vertically
            }}
          >
            <Typography sx={{ textAlign: "center", fontSize: "30px" }}>
              {Custom_AVG}
            </Typography>
          </Stack>

          {/* ------- TABLE SECTION ------- */}
          <Stack
            sx={{
              overflowX: "hidden !important",
            }}
            spacing={2}
          >
            <CommonAgGrid
              rowData={Custom_RowData}
              columnDefs={Custom_ColumnDefs}
              domLayout="autoHeight"
              className="custom-grid-theme"
              headerHeight={30}
              rowHeight={
                DAClass === "OnPeak" || DAClass === "OffPeak" ? 40 : 30
              }
              defaultColumnDefs={{
                filter: true,
              }}
              onCellValueChanged={handleCellValueChanged}
              onCellKeyDown={onCellKeyDown}
              onCellFocused={onCellFocused}
            />
            <Typography>
              Prices are calculated using ExPost, ExAnte, and DA ExPost LMPs.
            </Typography>
          </Stack>
        </Stack>

        <Stack
          sx={{
            padding: 0,
            borderRadius: 2,
            pt: 2,
            display: "flex",
            flex: 3,
            minWidth: 0,
            width: isMobile && "100%",
            border:
              theme.palette.mode === "dark"
                ? "1px solid #ffffffbd"
                : "1px solid #222222bd",
            px: 1,
          }}
          spacing={1}
        >
          <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
            Prices
          </Typography>
          {/* ------- TOP ROW WITH DIVIDER ------- */}
          <Stack
            direction="row"
            spacing={0}
            sx={{
              justifyContent: "center", // center horizontally
              alignItems: "center", // center vertically
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "30px",
                color: LatestMisoPriceChange > 0 ? "#30bf35" : "#da3d32",
              }}
            >
              Latest Price: {LatestMisoPrice} ({LatestMisoPriceChange}){" "}
              {LatestMisoPriceType}
            </Typography>
          </Stack>

          {/* ------- TABLE SECTION ------- */}
          <Stack
            sx={{
              height: "70vh",

              overflowX: "hidden !important",
            }}
            spacing={2}
          >
            <CommonAgGrid
              rowData={MISOPrices}
              columnDefs={MISOPrices_ColumnDefs}
              className="custom-grid-theme"
              defaultColumnDefs={{
                filter: true,
              }}
              headerHeight={30}
              rowHeight={30}
              pagination={true}
              paginationPageSize={isMobile ? 20 : 18}
              paginationPageSizeSelector={false}
            />
            <Typography>Times are interval ending UTC -5</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MISO;
